import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import TitlesServices from "./Titles.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getTitles = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_TITLES,
      payload: true,
    });
    const resp = await TitlesServices.getTitles(filters);
    dispatch({
      type: actions.GET_TITLES,
      payload: {
        titles: resp.data.data,
        titlesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.TITLES_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TITLES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TITLES,
      payload: false,
    });
  }
};

export const getTitlesById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_TITLES,
      payload: true,
    });
    const resp = await TitlesServices.getTitlesById(id);
    dispatch({
      type: actions.GET_TITLES,
      payload: {
        title: resp.data
      },
    });
    dispatch({
      type: actions.TITLES_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TITLES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TITLES,
      payload: false,
    });
  }
};

export const saveTitles = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_TITLES,
      payload: true,
    });
    const resp = await TitlesServices.saveTitles(data);
    const { titles, titlesLength } = getState().titles;
    const _Titles = [...titles, resp.data];
    dispatch({
      type: actions.GET_TITLES,
      payload: {
        titles: _Titles,
        titlesLength: titlesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: {},
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    let _message = {};
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            _message=ex.response.data
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: _message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_TITLES,
      payload: false,
    });
  }
};

export const editTitles = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_TITLES,
      payload: true,
    });
    const resp = await TitlesServices.editTitles(id, data);
    const { titles, titlesLength } = getState().titles;
    titles[index] = resp.data;
    dispatch({
      type: actions.GET_TITLES,
      payload: {
        titles: titles,
        titlesLength: titlesLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    let _message = {};
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            _message=ex.response.data
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: _message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TITLES,
      payload: false,
    });
  }
};

export const deleteTitles = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_TITLES,
      payload: true,
    });
    await TitlesServices.deleteTitles(id);
    const { titles, titlesLength } = getState().titles;
    titles.splice(index, 1);
    dispatch({
      type: actions.GET_TITLES,
      payload: {
        titles: titles,
        titlesLength: titlesLength - 1,
      },
    });
    dispatch({
      type: actions.TITLES_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TITLES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TITLES,
      payload: false,
    });
  }
};
